// extracted by mini-css-extract-plugin
export default {"tabHeader":"MyAccount_tabHeader__mv0vS"};